import { useTranslation } from "react-i18next";
import SiteLayout from "@/components/feature/SiteLayout";
import PageBanner from "@/components/feature/PageBanner";
import AboutSubNav from "@/components/feature/AboutSubNav";

interface Certification {
  name: string;
  fullName: string;
  year: string;
  desc: string;
  icon: string;
}

export default function AboutCertificationsPage() {
  const { t } = useTranslation();
  const certifications = t("about.certifications", { returnObjects: true }) as unknown as Certification[];

  return (
    <SiteLayout navVariant="solid">
      <PageBanner
        title={t("about.banners.certifications.title")}
        subtitle={t("about.banners.certifications.subtitle")}
        breadcrumb={[
          { label: t("about.companyLabel"), to: "/about/overview" },
          { label: t("about.banners.certifications.title") },
        ]}
        bgImage="https://readdy.ai/api/search-image?query=Modern%20clean%20industrial%20manufacturing%20facility%20interior%20with%20organized%20production%20floor%20and%20natural%20light%20streaming%20through%20windows%2C%20professional%20engineering%20environment%2C%20warm%20industrial%20aesthetic%2C%20soft%20ambient%20lighting%2C%20crisp%20architectural%20photography&width=1600&height=680&seq=krubber-about-banner&orientation=landscape"
      />
      <AboutSubNav />

      <section className="py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {certifications.map((cert) => (
              <div
                key={cert.name}
                className="p-8 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-colors group"
              >
                <span className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                  <i className={`${cert.icon} text-primary-600 text-xl`} />
                </span>
                <h3 className="mt-6 font-heading font-extrabold text-xl text-foreground-950">
                  {cert.name}
                </h3>
                <p className="text-sm font-semibold text-primary-600 mt-1">{cert.fullName}</p>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed">{cert.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}